import React from "react";

export const isModifiedMouseEvent = (event: React.MouseEvent<HTMLElement>) =>
	event.metaKey || event.ctrlKey || event.nativeEvent.button === 1;

export const openInNewTab = (url: string) => {
	window.open(url, "_blank", "noopener,noreferrer");
};

export const isValidInternalPath = (p?: string | null): p is string => {
	if (!p || typeof p !== "string") return false;
	if (!p.startsWith("/")) return false; // must start with '/'
	if (p.startsWith("//")) return false; // disallow protocol-relative
	// disallow scheme-like prefixes (e.g. 'http:' or 'javascript:')
	if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(p)) return false;
	return true;
};
